import styled from 'styled-components';

export const FilterDiv = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
`;
